import { SxProps } from '@mui/system';
import { Theme } from 'theme';

export const warningMessageStyle: SxProps<Theme> = theme => ({
	fontSize: '0.8em',
	fontStyle: 'italic',
	color: theme.secondaryColors.secondary13,
});
